import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FaCarSide } from 'react-icons/fa6';
import CarIcon from "./../../Assets/car_image.png"
const { Text } = Typography;

// EXACT same JSX from original Onde.jsx - NO CHANGES to layout/design/logic
const SimulationVisualization = ({
  showSimulation,
  setShowSimulation,
  result,
  viewMode,
  setViewMode,
  animationSpeed,
  animationActive,
  setAnimationActive,
  animationProgress,
  animationRef,
  startAnimation,
  offsetX,
  offsetY,
  maxDistance,
  totalPathDistance,
  firstSignalDistance = 0,
  signalElements,
  partenza,
  chartRef,
  containerHeight,
  maxTime,
  yAxisTicks,
  yScale,
  colorSuccess,
  colorError
}) => {
  // Draggable modal state
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef({ startX: 0, startY: 0, initialX: 0, initialY: 0 });

  // Reset position when modal opens
  useEffect(() => {
    if (showSimulation) {
      setPosition({ x: 0, y: 0 });
    }
  }, [showSimulation]);

  const handleMouseDown = useCallback((e) => {
    // Only start drag if clicking on the header (not buttons)
    if (e.target.closest('button')) return;

    setIsDragging(true);
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      initialX: position.x,
      initialY: position.y
    };
  }, [position]);

  const handleMouseMove = useCallback((e) => {
    if (!isDragging) return;

    const deltaX = e.clientX - dragRef.current.startX;
    const deltaY = e.clientY - dragRef.current.startY;

    setPosition({
      x: dragRef.current.initialX + deltaX,
      y: dragRef.current.initialY + deltaY
    });
  }, [isDragging]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  // Add/remove global event listeners for drag
  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  if (!showSimulation || !result?.risultati || result.risultati.length === 0) {
    return null;
  }

  return (
    <>
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
        width: '65%',
        maxWidth: '750px',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        zIndex: 2000,
        maxHeight: '75vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Modal Header - Draggable */}
        <div
          onMouseDown={handleMouseDown}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px 24px',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
            cursor: isDragging ? 'grabbing' : 'grab',
            userSelect: 'none'
          }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <FaCarSide size={20} style={{ color: '#333' }} />
            <div>
              <div style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#1a1a1a'
              }}>
                Simulazione Onda verde su direttrice
              </div>
              <div style={{
                fontSize: '13px',
                color: '#666',
                marginTop: '2px'
              }}>
                velocità: {animationSpeed} km/h
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            {/* View Toggle - EXACT same */}
            <div style={{
              background: '#504d41',
              borderRadius: '24px',
              padding: '4px',
              display: 'flex',
              gap: '4px'
            }}>
              <button
                onClick={() => setViewMode('1d')}
                style={{
                  padding: '8px 20px',
                  borderRadius: '20px',
                  border: 'none',
                  background: viewMode === '1d' ? '#A1E430' : 'transparent',
                  color: viewMode === '1d' ? '#1a1a1a' : '#fff',
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                1D
              </button>
              <button
                onClick={() => setViewMode('2d')}
                style={{
                  padding: '8px 20px',
                  borderRadius: '20px',
                  border: 'none',
                  background: viewMode === '2d' ? '#A1E430' : 'transparent',
                  color: viewMode === '2d' ? '#1a1a1a' : '#fff',
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                2D
              </button>
            </div>

            {/* Close Button - EXACT same */}
            <Button
              type="text"
              icon={<CloseOutlined style={{ color: '#666', fontSize: '18px' }} />}
              onClick={() => setShowSimulation(false)}
              style={{
                padding: 0,
                width: 32,
                height: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            />
          </div>
        </div>

        {/* Modal Body - EXACT same JSX from original */}
        <div style={{
          flex: 1,
          overflow: 'auto',
          padding: '24px'
        }}>
          {viewMode === "1d" ? (
            <>
              <div
                className="container-element"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "300px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "280px",
                    position: "relative",
                    background: "white",
                    borderRadius: 8,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: offsetX,
                      right: offsetX,
                      height: "1px",
                      backgroundColor: "#d9d9d9",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {[
                      0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550,
                      600, 650, 700, 750, 800,
                    ]
                      .filter((d) => d <= maxDistance)
                      .map((distance) => (
                        <div
                          key={distance}
                          style={{
                            position: "absolute",
                            left: `${distance * 1.2}px`,
                            top: 0,
                            transform: "translateX(-50%)",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "12px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              fontSize: 12,
                              color: "#666",
                            }}
                          >
                            {distance}m
                          </div>
                        </div>
                      ))}
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      left: offsetX,
                      right: offsetX,
                      top: 0,
                      bottom: 40,
                  
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: "50%",
                        height: "1px",
                        transform: "translateY(-50%)",
                        border : "none",
                        borderTop : "1px dashed  #DDE3EE",
                        background : "transparent"
                      }}
                    />

                    {signalElements}

                    {animationActive && (
                      <div
                        className="onde-animated-car"
                        style={{
                          left: `${
                            offsetX + (firstSignalDistance + animationProgress * (totalPathDistance - firstSignalDistance)) - 25
                          }px`,
                        }}
                      >
                        <img src={CarIcon} className="onde-car-icon" />
                      </div>
                    )}
                  </div>
                </div>

                {/* Play/Pause Button for 1D View - EXACT same */}
                <button
                  onClick={() => {
                    if (animationActive) {
                      setAnimationActive(false);
                      cancelAnimationFrame(animationRef.current);
                    } else {
                      startAnimation();
                    }
                  }}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #A1E430 0%, #8FD420 100%)',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(161, 228, 48, 0.3)',
                    transition: 'transform 0.2s',
                    zIndex: 10
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  {animationActive ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="6" y="4" width="4" height="16" fill="#1a1a1a"/>
                      <rect x="14" y="4" width="4" height="16" fill="#1a1a1a"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7L8 5z" fill="#1a1a1a"/>
                    </svg>
                  )}
                </button>
              </div>
            </>
          ) : (
            /* 2D View - EXACT same JSX */
            <div style={{
              width: "100%",
              height: "100%",
              minHeight: "300px",
              overflow: "hidden",
              position: "relative"
            }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  background: "white",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                }}
              >
                <div
                  ref={chartRef}
                  className="onde-chart-ref"
                  style={{
                    marginRight: offsetX,
                    marginBottom: offsetY,
                    minHeight: '280px',
                    height: '100%',
                  }}
                >
                  <div
                    className="onde-y-axis-label"
                    style={{
                      top: `calc(30% + ${offsetY}px)`,
                    }}
                  >
                    Distanza (m)
                  </div>

                  <div className="onde-x-axis-container">
                    {[
                      0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220,
                      240, 260, 280, 300,
                    ]
                      .filter((d) => d <= maxTime)
                      .map((time) => (
                        <div
                          key={time}
                          className="onde-x-axis-tick"
                          style={{
                            left: `${time * 3 + offsetX}px`,
                          }}
                        >
                          <div className="onde-x-axis-label">{time}s</div>
                        </div>
                      ))}
                  </div>

                  <div className="onde-y-axis-container">
                    {yAxisTicks.map((distance) => (
                      <div
                        key={distance}
                        className="onde-y-axis-tick"
                        style={{
                          bottom: `${offsetY + distance * yScale}px`,
                        }}
                      >
                        <div className="onde-y-axis-tick-label">
                          {distance}m
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="onde-green-wave-container">
                    <div className="onde-green-wave-inner">
                      <svg
                        id="lines-container"
                        className="onde-lines-container"
                      >
                        {result.risultati.map((signal, index) => {
                          if (index >= result.risultati.length - 1)
                            return null;

                          const yPos = signal.distanza * yScale;
                          const xPos = signal.inizio_verde * 3 + offsetX - 10;

                          const nextSignal = result.risultati[index + 1];

                          const nextYPos = nextSignal.distanza * yScale;
                          const nextXPos =
                            nextSignal.inizio_verde * 3 + offsetX - 10;

                          return (
                            <line
                              key={`line-${index}-start`}
                              className="onde-green-line"
                              x1={`${xPos}px`}
                              y1={`${
                                containerHeight + 1 - (offsetY + yPos)
                              }px`}
                              x2={`${nextXPos}px`}
                              y2={`${
                                containerHeight + 1 - (offsetY + nextYPos)
                              }px`}
                            />
                          );
                        })}

                        {result.risultati.map((signal, index, array) => {
                          if (index >= result.risultati.length - 1)
                            return null;
                          var min = Math.min(
                            ...result.risultati.map(
                              (item) =>
                                (item.fine_verde - item.inizio_verde) * 3
                            )
                          );
                          const yPos = signal.distanza * yScale;
                          const xPos = signal.inizio_verde * 3 + offsetX - 10;

                          const nextSignal = result.risultati[index + 1];

                          const nextYPos = nextSignal.distanza * yScale;
                          const nextXPos =
                            nextSignal.inizio_verde * 3 + offsetX - 10;

                          return (
                            <line
                              key={`line-${index}-end`}
                              className="onde-green-line-solid"
                              x1={`${min + xPos}px`}
                              y1={`${
                                containerHeight + 1 - (offsetY + yPos)
                              }px`}
                              x2={`${min + nextXPos}px`}
                              y2={`${
                                containerHeight + 1 - (offsetY + nextYPos)
                              }px`}
                            />
                          );
                        })}
                      </svg>
                    </div>
                  </div>

                  {result.risultati.map((signal, index) => {
                    const yPos = signal.distanza * yScale;
                    const xPos = signal.inizio_verde * 3 + offsetX;
                    const width =
                      (signal.fine_verde - signal.inizio_verde) * 3;

                    return (
                      <React.Fragment key={index}>
                        <div
                          className="onde-signal-2d"
                          style={{
                            left: `${width / 2 + xPos - 10}px`,
                            bottom: `${offsetY + yPos - 12}px`,
                          }}
                        >
                          {signal.semaforo}
                        </div>

                        <div
                          className="onde-signal-bar-2d"
                          style={{
                            left: `${width / 2 + xPos - 10}px`,
                            width: `${width}px`,
                            bottom: `${offsetY + yPos - 5}px`,
                            borderColor: colorSuccess,
                          }}
                        />
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Legend - EXACT same */}
          <div className="onde-legend">
            <div className="onde-legend-item">
              <div className="onde-legend-car-icon">
                <FaCarSide className="onde-legend-car-svg" />
              </div>
              <Text>Veicolo</Text>
            </div>
            <div className="onde-legend-item">
              <div
                className="onde-legend-dot red"
                style={{
                  backgroundColor: colorError,
                }}
              />
              <Text>Semaforo rosso</Text>
            </div>
            <div className="onde-legend-item">
              <div
                className="onde-legend-dot green"
                style={{
                  backgroundColor: colorSuccess,
                }}
              />
              <Text>Semaforo verde</Text>
            </div>
          </div>
        </div>
      </div>

      {/* Transparent overlay - allows map interaction while modal is open */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'transparent',
          zIndex: 1999,
          pointerEvents: 'none'
        }}
      />
    </>
  );
};

export default SimulationVisualization;